module.exports = __webpack_public_path__ + "img/republic-of-macedonia.467339a3.png";